import * as actionTypes from './types';


const INITIAL_KEY_STATE = {
	value: null
};

const INITIAL_STATE = {
	value: {
		visible: false,
		theme: 'universal',
		template: 'food',
		currency: '₹',
		role: 'Reader',
		language: 'en-US',
		header: true,
		footer: true,
		sidebar: true,
		tenantName: 'agri',
		getQuote: 'close',
		getUploadFiles: 'close',
		getUploadModal: 'close',
		getDeleteModal: 'close'
	},
	set: INITIAL_KEY_STATE,
};


const settingsReducer = (state = INITIAL_STATE, action: any) => {
	const { payload } = action;
	switch (action.type) {
		case actionTypes.SET_DATA:

			return {
				value: {
					...state.value,
					...payload
				}
			};
		default:
			return state;
	}
};

export default settingsReducer;
